import React from 'react'
import { Divider, ListItemIcon, makeStyles, Menu, MenuItem } from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import Check from '@material-ui/icons/Check'
import Button from '../Button'
import Avatar from '../Avatar'

const CustomizedMenu = ({ ...overrides }) => (
  <Menu
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    elevation={4}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...overrides}
  />
)
const useStyles = makeStyles(() => ({
  listItem: {
    paddingRight: '16px',
  },
}))

const CustomizedProfileSwitcher = ({ ...overrides }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [activeProfile, setActiveProfile] = React.useState(
    overrides.activeProfile ? overrides.activeProfile : null
  )
  const open = Boolean(anchorEl)
  const classes = useStyles()

  const className = overrides.className
  const ButtonProps = overrides.ButtonProps
  const MenuProps = overrides.MenuProps
  const { onClick: menuItemClick, ...rest } = overrides.MenuItemProps

  const handleMenuClick = event => setAnchorEl(event.currentTarget)

  const handleMenuItemClick = event => {
    setActiveProfile(overrides.items.find(item => item.id === event.currentTarget.value))
    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={className}>
      <Button
        id="profile-switcher-button"
        variant="contained"
        onClick={handleMenuClick}
        endIcon={<KeyboardArrowDownIcon />}
        {...ButtonProps}
      >
        <Avatar>{activeProfile ? activeProfile.avatar : null}</Avatar>
      </Button>
      <CustomizedMenu
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        open={open}
        onClose={handleClose}
        {...MenuProps}
      >
        {overrides.items.map((item, idx) => (
          <div>
            <MenuItem
              className={classes.listItem}
              onClick={e => {
                handleMenuItemClick(e)
                menuItemClick && menuItemClick(e)
              }}
              selected={activeProfile ? item.id === activeProfile.id : null}
              value={item.id}
              {...rest}
            >
              {item.name}
              {activeProfile && item.id === activeProfile.id && (
                <ListItemIcon>
                  <Check color="secondary" />
                </ListItemIcon>
              )}
            </MenuItem>
            {idx !== overrides.items.length - 1 ? <Divider /> : null}
          </div>
        ))}
      </CustomizedMenu>
    </div>
  )
}

export default CustomizedProfileSwitcher
